/** Agent transactions page — non-English overrides */
export const panelAgentTransactionsByLang = {
  es: {
    'agent.transactions.sectionTitle': 'Historial de transacciones',
    'agent.transactions.loading': 'Cargando transacciones…',
    'agent.transactions.emptyTitle': 'No se encontraron transacciones',
    'agent.transactions.emptyLoadingHint': 'Espera…',
    'agent.transactions.emptyHint': 'Prueba a ajustar los filtros.',
    'agent.transactions.col.date': 'Fecha y hora',
    'agent.transactions.col.type': 'Tipo',
    'agent.transactions.col.description': 'Descripción',
    'agent.transactions.col.amount': 'Monto',
    'agent.transactions.col.status': 'Estado',
    'agent.transactions.col.txid': 'TXID',
    'agent.transactions.footerShowing': 'Mostrando 1–{{to}} de {{total}}',
    'agent.transactions.prev': 'Anterior',
    'agent.transactions.next': 'Siguiente',
    'agent.transactions.pending': 'Pendiente',
    'agent.transactions.filter.all': 'Todos',
    'agent.transactions.filter.from': 'Desde',
    'agent.transactions.filter.to': 'Hasta',
    'agent.transactions.filter.searchPlaceholder': 'Buscar TXID o descripción…',
    'agent.transactions.type.commission': 'Comisión',
    'agent.transactions.type.withdrawal': 'Retiro',
    'agent.transactions.type.rankReward': 'Recompensa de rango',
    'agent.transactions.status.pending': 'Pendiente',
    'agent.transactions.status.paid': 'Pagado',
    'agent.transactions.status.completed': 'Completado',
    'agent.transactions.status.failed': 'Fallido',
    'agent.transactions.status.rejected': 'Rechazado',
    'agent.transactions.status.cancelled': 'Cancelado',
  },
  de: {
    'agent.transactions.sectionTitle': 'Transaktionsverlauf',
    'agent.transactions.loading': 'Transaktionen werden geladen…',
    'agent.transactions.emptyTitle': 'Keine Transaktionen gefunden',
    'agent.transactions.emptyLoadingHint': 'Bitte warten…',
    'agent.transactions.emptyHint': 'Passen Sie Ihre Filter an.',
    'agent.transactions.col.date': 'Datum & Uhrzeit',
    'agent.transactions.col.type': 'Typ',
    'agent.transactions.col.description': 'Beschreibung',
    'agent.transactions.col.amount': 'Betrag',
    'agent.transactions.col.status': 'Status',
    'agent.transactions.col.txid': 'TXID',
    'agent.transactions.footerShowing': 'Zeige 1–{{to}} von {{total}}',
    'agent.transactions.prev': 'Zurück',
    'agent.transactions.next': 'Weiter',
    'agent.transactions.pending': 'Ausstehend',
    'agent.transactions.filter.all': 'Alle',
    'agent.transactions.filter.from': 'Von',
    'agent.transactions.filter.to': 'Bis',
    'agent.transactions.filter.searchPlaceholder': 'TXID oder Beschreibung suchen…',
    'agent.transactions.type.commission': 'Provision',
    'agent.transactions.type.withdrawal': 'Auszahlung',
    'agent.transactions.type.rankReward': 'Rangprämie',
    'agent.transactions.status.pending': 'Ausstehend',
    'agent.transactions.status.paid': 'Bezahlt',
    'agent.transactions.status.completed': 'Abgeschlossen',
    'agent.transactions.status.failed': 'Fehlgeschlagen',
    'agent.transactions.status.rejected': 'Abgelehnt',
    'agent.transactions.status.cancelled': 'Storniert',
  },
  fr: {
    'agent.transactions.sectionTitle': 'Historique des transactions',
    'agent.transactions.loading': 'Chargement des transactions…',
    'agent.transactions.emptyTitle': 'Aucune transaction trouvée',
    'agent.transactions.emptyLoadingHint': 'Veuillez patienter…',
    'agent.transactions.emptyHint': 'Essayez d\'ajuster vos filtres.',
    'agent.transactions.col.date': 'Date et heure',
    'agent.transactions.col.type': 'Type',
    'agent.transactions.col.description': 'Description',
    'agent.transactions.col.amount': 'Montant',
    'agent.transactions.col.status': 'Statut',
    'agent.transactions.col.txid': 'TXID',
    'agent.transactions.footerShowing': 'Affichage 1–{{to}} sur {{total}}',
    'agent.transactions.prev': 'Préc.',
    'agent.transactions.next': 'Suiv.',
    'agent.transactions.pending': 'En attente',
    'agent.transactions.filter.all': 'Tous',
    'agent.transactions.filter.from': 'Du',
    'agent.transactions.filter.to': 'Au',
    'agent.transactions.filter.searchPlaceholder': 'Rechercher TXID ou description…',
    'agent.transactions.type.commission': 'Commission',
    'agent.transactions.type.withdrawal': 'Retrait',
    'agent.transactions.type.rankReward': 'Récompense de rang',
    'agent.transactions.status.pending': 'En attente',
    'agent.transactions.status.paid': 'Payé',
    'agent.transactions.status.completed': 'Terminé',
    'agent.transactions.status.failed': 'Échoué',
    'agent.transactions.status.rejected': 'Rejeté',
    'agent.transactions.status.cancelled': 'Annulé',
  },
  ar: {
    'agent.transactions.sectionTitle': 'سجل المعاملات',
    'agent.transactions.loading': 'جاري تحميل المعاملات…',
    'agent.transactions.emptyTitle': 'لا توجد معاملات',
    'agent.transactions.emptyLoadingHint': 'يرجى الانتظار…',
    'agent.transactions.emptyHint': 'جرّب تعديل المرشحات.',
    'agent.transactions.col.date': 'التاريخ والوقت',
    'agent.transactions.col.type': 'النوع',
    'agent.transactions.col.description': 'الوصف',
    'agent.transactions.col.amount': 'المبلغ',
    'agent.transactions.col.status': 'الحالة',
    'agent.transactions.col.txid': 'TXID',
    'agent.transactions.footerShowing': 'عرض 1–{{to}} من {{total}}',
    'agent.transactions.prev': 'السابق',
    'agent.transactions.next': 'التالي',
    'agent.transactions.pending': 'قيد الانتظار',
    'agent.transactions.filter.all': 'الكل',
    'agent.transactions.filter.from': 'من',
    'agent.transactions.filter.to': 'إلى',
    'agent.transactions.filter.searchPlaceholder': 'بحث في TXID أو الوصف…',
    'agent.transactions.type.commission': 'عمولة',
    'agent.transactions.type.withdrawal': 'سحب',
    'agent.transactions.type.rankReward': 'مكافأة المستوى',
    'agent.transactions.status.pending': 'قيد الانتظار',
    'agent.transactions.status.paid': 'مدفوع',
    'agent.transactions.status.completed': 'مكتمل',
    'agent.transactions.status.failed': 'فشل',
    'agent.transactions.status.rejected': 'مرفوض',
    'agent.transactions.status.cancelled': 'ملغى',
  },
  ja: {
    'agent.transactions.sectionTitle': '取引履歴',
    'agent.transactions.loading': '取引を読み込み中…',
    'agent.transactions.emptyTitle': '取引が見つかりません',
    'agent.transactions.emptyLoadingHint': 'お待ちください…',
    'agent.transactions.emptyHint': 'フィルターを調整してみてください。',
    'agent.transactions.col.date': '日時',
    'agent.transactions.col.type': '種類',
    'agent.transactions.col.description': '説明',
    'agent.transactions.col.amount': '金額',
    'agent.transactions.col.status': 'ステータス',
    'agent.transactions.col.txid': 'TXID',
    'agent.transactions.footerShowing': '1–{{to}} / {{total}} 件を表示',
    'agent.transactions.prev': '前へ',
    'agent.transactions.next': '次へ',
    'agent.transactions.pending': '保留中',
    'agent.transactions.filter.all': 'すべて',
    'agent.transactions.filter.from': '開始',
    'agent.transactions.filter.to': '終了',
    'agent.transactions.filter.searchPlaceholder': 'TXIDまたは説明を検索…',
    'agent.transactions.type.commission': 'コミッション',
    'agent.transactions.type.withdrawal': '出金',
    'agent.transactions.type.rankReward': 'ランク報酬',
    'agent.transactions.status.pending': '保留中',
    'agent.transactions.status.paid': '支払済み',
    'agent.transactions.status.completed': '完了',
    'agent.transactions.status.failed': '失敗',
    'agent.transactions.status.rejected': '拒否',
    'agent.transactions.status.cancelled': 'キャンセル',
  },
  ko: {
    'agent.transactions.sectionTitle': '거래 내역',
    'agent.transactions.loading': '거래 불러오는 중…',
    'agent.transactions.emptyTitle': '거래를 찾을 수 없습니다',
    'agent.transactions.emptyLoadingHint': '잠시만 기다려 주세요…',
    'agent.transactions.emptyHint': '필터를 조정해 보세요.',
    'agent.transactions.col.date': '날짜 및 시간',
    'agent.transactions.col.type': '유형',
    'agent.transactions.col.description': '설명',
    'agent.transactions.col.amount': '금액',
    'agent.transactions.col.status': '상태',
    'agent.transactions.col.txid': 'TXID',
    'agent.transactions.footerShowing': '1–{{to}} / {{total}}건 표시',
    'agent.transactions.prev': '이전',
    'agent.transactions.next': '다음',
    'agent.transactions.pending': '대기 중',
    'agent.transactions.filter.all': '전체',
    'agent.transactions.filter.from': '시작',
    'agent.transactions.filter.to': '종료',
    'agent.transactions.filter.searchPlaceholder': 'TXID 또는 설명 검색…',
    'agent.transactions.type.commission': '커미션',
    'agent.transactions.type.withdrawal': '출금',
    'agent.transactions.type.rankReward': '랭크 보상',
    'agent.transactions.status.pending': '대기 중',
    'agent.transactions.status.paid': '지급됨',
    'agent.transactions.status.completed': '완료',
    'agent.transactions.status.failed': '실패',
    'agent.transactions.status.rejected': '거절됨',
    'agent.transactions.status.cancelled': '취소됨',
  },
  'zh-CN': {
    'agent.transactions.sectionTitle': '交易记录',
    'agent.transactions.loading': '正在加载交易…',
    'agent.transactions.emptyTitle': '未找到交易',
    'agent.transactions.emptyLoadingHint': '请稍候…',
    'agent.transactions.emptyHint': '请尝试调整筛选条件。',
    'agent.transactions.col.date': '日期和时间',
    'agent.transactions.col.type': '类型',
    'agent.transactions.col.description': '说明',
    'agent.transactions.col.amount': '金额',
    'agent.transactions.col.status': '状态',
    'agent.transactions.col.txid': 'TXID',
    'agent.transactions.footerShowing': '显示 1–{{to}}，共 {{total}} 条',
    'agent.transactions.prev': '上一页',
    'agent.transactions.next': '下一页',
    'agent.transactions.pending': '待处理',
    'agent.transactions.filter.all': '全部',
    'agent.transactions.filter.from': '从',
    'agent.transactions.filter.to': '至',
    'agent.transactions.filter.searchPlaceholder': '搜索 TXID 或说明…',
    'agent.transactions.type.commission': '佣金',
    'agent.transactions.type.withdrawal': '提现',
    'agent.transactions.type.rankReward': '等级奖励',
    'agent.transactions.status.pending': '待处理',
    'agent.transactions.status.paid': '已支付',
    'agent.transactions.status.completed': '已完成',
    'agent.transactions.status.failed': '失败',
    'agent.transactions.status.rejected': '已拒绝',
    'agent.transactions.status.cancelled': '已取消',
  },
  pt: {
    'agent.transactions.sectionTitle': 'Histórico de transações',
    'agent.transactions.loading': 'Carregando transações…',
    'agent.transactions.emptyTitle': 'Nenhuma transação encontrada',
    'agent.transactions.emptyLoadingHint': 'Aguarde…',
    'agent.transactions.emptyHint': 'Tente ajustar os filtros.',
    'agent.transactions.col.date': 'Data e hora',
    'agent.transactions.col.type': 'Tipo',
    'agent.transactions.col.description': 'Descrição',
    'agent.transactions.col.amount': 'Valor',
    'agent.transactions.col.status': 'Status',
    'agent.transactions.col.txid': 'TXID',
    'agent.transactions.footerShowing': 'Mostrando 1–{{to}} de {{total}}',
    'agent.transactions.prev': 'Anterior',
    'agent.transactions.next': 'Próximo',
    'agent.transactions.pending': 'Pendente',
    'agent.transactions.filter.all': 'Todos',
    'agent.transactions.filter.from': 'De',
    'agent.transactions.filter.to': 'Até',
    'agent.transactions.filter.searchPlaceholder': 'Pesquisar TXID ou descrição…',
    'agent.transactions.type.commission': 'Comissão',
    'agent.transactions.type.withdrawal': 'Saque',
    'agent.transactions.type.rankReward': 'Recompensa de rank',
    'agent.transactions.status.pending': 'Pendente',
    'agent.transactions.status.paid': 'Pago',
    'agent.transactions.status.completed': 'Concluído',
    'agent.transactions.status.failed': 'Falhou',
    'agent.transactions.status.rejected': 'Rejeitado',
    'agent.transactions.status.cancelled': 'Cancelado',
  },
  it: {
    'agent.transactions.sectionTitle': 'Cronologia transazioni',
    'agent.transactions.loading': 'Caricamento transazioni…',
    'agent.transactions.emptyTitle': 'Nessuna transazione trovata',
    'agent.transactions.emptyLoadingHint': 'Attendere…',
    'agent.transactions.emptyHint': 'Prova a modificare i filtri.',
    'agent.transactions.col.date': 'Data e ora',
    'agent.transactions.col.type': 'Tipo',
    'agent.transactions.col.description': 'Descrizione',
    'agent.transactions.col.amount': 'Importo',
    'agent.transactions.col.status': 'Stato',
    'agent.transactions.col.txid': 'TXID',
    'agent.transactions.footerShowing': 'Visualizzazione 1–{{to}} di {{total}}',
    'agent.transactions.prev': 'Prec.',
    'agent.transactions.next': 'Succ.',
    'agent.transactions.pending': 'In attesa',
    'agent.transactions.filter.all': 'Tutti',
    'agent.transactions.filter.from': 'Da',
    'agent.transactions.filter.to': 'A',
    'agent.transactions.filter.searchPlaceholder': 'Cerca TXID o descrizione…',
    'agent.transactions.type.commission': 'Commissione',
    'agent.transactions.type.withdrawal': 'Prelievo',
    'agent.transactions.type.rankReward': 'Ricompensa rango',
    'agent.transactions.status.pending': 'In attesa',
    'agent.transactions.status.paid': 'Pagato',
    'agent.transactions.status.completed': 'Completato',
    'agent.transactions.status.failed': 'Non riuscito',
    'agent.transactions.status.rejected': 'Rifiutato',
    'agent.transactions.status.cancelled': 'Annullato',
  },
  ru: {
    'agent.transactions.sectionTitle': 'История транзакций',
    'agent.transactions.loading': 'Загрузка транзакций…',
    'agent.transactions.emptyTitle': 'Транзакции не найдены',
    'agent.transactions.emptyLoadingHint': 'Подождите…',
    'agent.transactions.emptyHint': 'Попробуйте изменить фильтры.',
    'agent.transactions.col.date': 'Дата и время',
    'agent.transactions.col.type': 'Тип',
    'agent.transactions.col.description': 'Описание',
    'agent.transactions.col.amount': 'Сумма',
    'agent.transactions.col.status': 'Статус',
    'agent.transactions.col.txid': 'TXID',
    'agent.transactions.footerShowing': 'Показано 1–{{to}} из {{total}}',
    'agent.transactions.prev': 'Назад',
    'agent.transactions.next': 'Далее',
    'agent.transactions.pending': 'В ожидании',
    'agent.transactions.filter.all': 'Все',
    'agent.transactions.filter.from': 'С',
    'agent.transactions.filter.to': 'По',
    'agent.transactions.filter.searchPlaceholder': 'Поиск TXID или описания…',
    'agent.transactions.type.commission': 'Комиссия',
    'agent.transactions.type.withdrawal': 'Вывод',
    'agent.transactions.type.rankReward': 'Награда за ранг',
    'agent.transactions.status.pending': 'В ожидании',
    'agent.transactions.status.paid': 'Выплачено',
    'agent.transactions.status.completed': 'Завершено',
    'agent.transactions.status.failed': 'Ошибка',
    'agent.transactions.status.rejected': 'Отклонено',
    'agent.transactions.status.cancelled': 'Отменено',
  },
  bn: {
    'agent.transactions.sectionTitle': 'লেনদেনের ইতিহাস',
    'agent.transactions.loading': 'লেনদেন লোড হচ্ছে…',
    'agent.transactions.emptyTitle': 'কোনো লেনদেন পাওয়া যায়নি',
    'agent.transactions.emptyLoadingHint': 'অনুগ্রহ করে অপেক্ষা করুন…',
    'agent.transactions.emptyHint': 'ফিল্টার সামঞ্জস্য করে দেখুন।',
    'agent.transactions.col.date': 'তারিখ ও সময়',
    'agent.transactions.col.type': 'ধরন',
    'agent.transactions.col.description': 'বিবরণ',
    'agent.transactions.col.amount': 'পরিমাণ',
    'agent.transactions.col.status': 'স্থিতি',
    'agent.transactions.col.txid': 'TXID',
    'agent.transactions.footerShowing': '১–{{to}} / {{total}} দেখানো হচ্ছে',
    'agent.transactions.prev': 'আগে',
    'agent.transactions.next': 'পরে',
    'agent.transactions.pending': 'মুলতুবি',
    'agent.transactions.filter.all': 'সব',
    'agent.transactions.filter.from': 'থেকে',
    'agent.transactions.filter.to': 'পর্যন্ত',
    'agent.transactions.filter.searchPlaceholder': 'TXID বা বিবরণ খুঁজুন…',
    'agent.transactions.type.commission': 'কমিশন',
    'agent.transactions.type.withdrawal': 'উত্তোলন',
    'agent.transactions.type.rankReward': 'র‍্যাঙ্ক পুরস্কার',
    'agent.transactions.status.pending': 'মুলতুবি',
    'agent.transactions.status.paid': 'পরিশোধিত',
    'agent.transactions.status.completed': 'সম্পন্ন',
    'agent.transactions.status.failed': 'ব্যর্থ',
    'agent.transactions.status.rejected': 'প্রত্যাখ্যাত',
    'agent.transactions.status.cancelled': 'বাতিল',
  },
  hi: {
    'agent.transactions.sectionTitle': 'लेन-देन इतिहास',
    'agent.transactions.loading': 'लेन-देन लोड हो रहे हैं…',
    'agent.transactions.emptyTitle': 'कोई लेन-देन नहीं मिला',
    'agent.transactions.emptyLoadingHint': 'कृपया प्रतीक्षा करें…',
    'agent.transactions.emptyHint': 'फ़िल्टर समायोजित करके देखें।',
    'agent.transactions.col.date': 'दिनांक और समय',
    'agent.transactions.col.type': 'प्रकार',
    'agent.transactions.col.description': 'विवरण',
    'agent.transactions.col.amount': 'राशि',
    'agent.transactions.col.status': 'स्थिति',
    'agent.transactions.col.txid': 'TXID',
    'agent.transactions.footerShowing': '1–{{to}} / {{total}} दिखा रहे हैं',
    'agent.transactions.prev': 'पिछला',
    'agent.transactions.next': 'अगला',
    'agent.transactions.pending': 'लंबित',
    'agent.transactions.filter.all': 'सभी',
    'agent.transactions.filter.from': 'से',
    'agent.transactions.filter.to': 'तक',
    'agent.transactions.filter.searchPlaceholder': 'TXID या विवरण खोजें…',
    'agent.transactions.type.commission': 'कमीशन',
    'agent.transactions.type.withdrawal': 'निकासी',
    'agent.transactions.type.rankReward': 'रैंक इनाम',
    'agent.transactions.status.pending': 'लंबित',
    'agent.transactions.status.paid': 'भुगतान किया',
    'agent.transactions.status.completed': 'पूर्ण',
    'agent.transactions.status.failed': 'विफल',
    'agent.transactions.status.rejected': 'अस्वीकृत',
    'agent.transactions.status.cancelled': 'रद्द',
  },
};
